import { IComponentSource, ComponentModel, compressComponentSource, MarkdownComponent, peek, headingPattern, thickRulePattern, thinRulePattern } from "./core";
import { applyTextDecoration } from "./text-decoration";

export interface IParagraphOrHeaderComponentModel extends IComponentSource {
  headerLevel?: number;
  text: string;
}

class ParagraphOrHeaderComponentModel extends ComponentModel implements IParagraphOrHeaderComponentModel {
  public headerLevel?: number | undefined = undefined;
  public text: string = '';
}

export const buildParagraphComponentModel = (source: IComponentSource) => {
  const lastPart = peek(source.content)!.content;
  let headerLevel: number | undefined = undefined;
  if(thickRulePattern.test(lastPart)) {
    headerLevel = 1;
  } else if(thinRulePattern.test(lastPart)) {
    headerLevel = 2;
  }

  if(headerLevel !== undefined) {
    source.type = MarkdownComponent.Heading;
    source.content.pop();
  }
  compressComponentSource(source, true);
  const paragraphComponent = new ParagraphOrHeaderComponentModel(source);
  paragraphComponent.headerLevel = headerLevel;

  const text = source.content[0].content;
  paragraphComponent.text = applyTextDecoration(source.type, text);
  
  return paragraphComponent;
}

export const buildHeadingComponentModel = (source: IComponentSource) => {
  compressComponentSource(source, true);
  const headingComponent = new ParagraphOrHeaderComponentModel(source);
  const line = source.content[0].content;

  const headingDefinition = line.match(headingPattern)![0].trim();
  headingComponent.headerLevel = headingDefinition.length;

  const text = line.replace(headingPattern, '');
  headingComponent.text = applyTextDecoration(MarkdownComponent.Heading, text);
  
  return headingComponent;
}